###
# Параметры компонента:
#   type: ['toggle', 'select', 'text', 'image', 'color']
#   name: string
#   text: string
#   values: [Object]
###
App.ThemeParameterComponent = Em.Component.extend
  classNames: ['theme-parameter']

  skin:   null
  option: null
  onParameterChanged: ''
  isLoading: false

  isColorpickerShown: false
  isSelectShown: false

  initializeProperties: (->
    for type in ['toggle', 'select', 'text', 'image', 'color']
      Em.defineProperty @, 'is' + type.capitalize(), Em.computed.equal('option.type', type)
  ).on('init')

  optionTextTranslated: (->
    @get("option.text_#{Em.I18n.locale}") || @get('option.text')
  ).property('option.text')
  optionValue: (->
    config = @get('skin.configuration')
    return null unless config

    config[ @get('option.name') ] ? {}
  ).property(
    'skin.configuration',
    'option.name')

  ###
  # Для типа 'toggle'
  ###
  toggleValue: ((key, value, previousValue) ->
    return null unless @get('isToggle')

    if arguments.length > 1
      @get('skin').configure(@get('option.name'), { type: 'toggle', value}).then =>
        @sendAction 'onParameterChanged'

    @get('optionValue.value')
  ).property(
    'optionValue'
    'optionValue.value')

  ###
  # Для типа 'image'
  ###
  imageStyle: (->
    return ''.htmlSafe() unless @get('isImage') or @get('isColor')

    optionName = @get('option.name')
    value  = @get('optionValue.value')
    type   = @get('optionValue.type')

    media = @get('skin.skin_media')

    if type is 'image' and Em.isArray(media)
      mediaItem = media.findBy('option_name', optionName)
      return "background-image: url(#{ mediaItem?.photo?.small_square })".htmlSafe()

    if type is 'color'
      return "background-color: #{value}".htmlSafe()
  ).property(
    'option.name',
    'optionValue.type',
    'optionValue.value',
    'skin.skin_media')

  ###
  # Для типа 'text'
  ###
  textValueBinding: Em.Binding.oneWay('optionValue.value')

  ###
  # Для типа 'color'
  ###
  colorValueBinding: Em.Binding.oneWay('optionValue.value')

  ###
  # Для типа 'select'
  ###
  selectOptions: (->
    return unless @get('isSelect')

    selectedValue = @get('optionValue.value')
    @get('option.values').map (v) ->
      value: v.value
      text: v["text_#{Em.I18n.locale}"] || v.text
      isSelected: (v.value is selectedValue)
  ).property(
    'option.values.[]',
    'optionValue.value')

  selectedItem: (->
    return unless @get('isSelect')
    selectedValue = @get('optionValue.value')
    item = @get('option.values').filter((v) -> (v.value is selectedValue))[0]
    if item
      Ember.set(item, 'text', item["text_#{Em.I18n.locale}"] || item.text)
    item
  ).property(
    'optionValue.value',
    'option.values.[]')

  actions:
    assignSelectValue: (value) ->
      @set('isSelectShown', false)
      skin  = @get('skin')
      skin.configure(@get('option.name'), { type: 'select', value })
      .then =>
        @sendAction 'onParameterChanged'
      false

    colorChanged: (value) ->
      skin  = @get('skin')
      skin.configure(@get('option.name'), { type: 'color', value })
      .then =>
        @sendAction 'onParameterChanged'

      @set('isColorpickerShown', false)
      false

    textValueChanged: ->
      value = @get('textValue')
      skin  = @get('skin')
      skin.configure(@get('option.name'), { type: 'text', value })
      .then =>
        @sendAction 'onParameterChanged'
      false

    openFileDialog: ->
      @get('fileInput').send('openDialog')
      false

    uploadPhoto: (file) ->
      @set('isLoading', true)
      skin = @get('skin')
      skin.uploadPhoto(@get('option.name'), file)
      .then =>
        skin.configure(@get('option.name'), { type: 'image', value: @get('option.name')})
      .then =>
        @set('isLoading', false)
        @sendAction 'onParameterChanged'

      false

    removePhoto: () ->
      if confirm 'Удалить установленное изображение?'
        @get('skin').configure(@get('option.name'), { type: 'color', value: 'rgba(0,0,0,0)'})
        @sendAction 'onParameterChanged'

      false

    toggleColorpicker: (event) ->
      @toggleProperty('isColorpickerShown')
      false

    toggleSelect: (event) ->
      @toggleProperty('isSelectShown')
      false


